// Import Components 
import Navbar from "../components/navbar";

const Contact = () => {
    return (
      <>
        <Navbar classNav="nav-dark-bg"/>
      
      </>
    );
  };
  
  export default Contact;